module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/1f7b123ef7b9366e240cc9c533556fc1.png";